import { useEffect, useState } from "react";
import axios from "axios";
import { getAccessToken } from "../Auth/auth";

const useConfig = (initialConfig) => {
  const [config, setConfig] = useState(initialConfig || {});

  useEffect(() => {
    setConfig(initialConfig || {});
  }, [initialConfig]);

  const saveConfig = async (configId, newConfig) => {
    try {
      const token = await getAccessToken();

      await axios.put(
        "https://01s8aky6al.execute-api.us-east-2.amazonaws.com/dev/admin",
        {
          configId,
          data: newConfig,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert("Changes saved successfully!");
    } catch (err) {
      console.error(err);
      alert("Error saving changes.");
    }
  };

  return { config, setConfig, saveConfig };
};

export default useConfig;